import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import type { RoleFormInput } from '../schemas/roleSchemas';
import { roleKeys } from './roleKeys';

export function useCreateRole() {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: (body: RoleFormInput) =>
      apiClient.post(`api/v1/t/${tenantId}/roles`, { json: body }).json(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: roleKeys.lists() });
      qc.invalidateQueries({ queryKey: ['roles', 'list', tenantId] });
    },
  });
}
